<template>
    <div class="fadein">
        <div class="h30"></div>
        <transition name="fade">
        <div class="center1200 bg-white temp-1 shadow">
            <div class="h20"></div>
            <div class="center-title">
              <span v-if="users_length>0"><a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> 用户搜索结果：{{keyword}} <img class="title-pic" src="/static/img/title-right.png" alt=""></a></span>
              <span v-else><a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> 暂无数据 <img class="title-pic" src="/static/img/title-right.png" alt=""></a></span>
              
            </div>
            <div class="h20"></div>
            <div v-if="users_length>0">
                <div class="user-boxes">

                    <div v-for="v in users" class="user-box">
                        <a href="javascript:;" @click="goUserinfo(v.user_id)" class="username">
                            <img :src="v.user_pic" alt="" class="user-head" v-if="v.user_pic != 'http://'+ $API_URL">
                            <img src="/static/img/default_userpic.png" alt="" class="user-head" v-else>
                        <!-- </a> -->
                        <div class="ellipsis">
                            <!-- <a href="javascript:;" @click="goUserinfo(v.user_id)" > -->
                                {{v.nickname}}
                            </div>
                        </a>
                        
                    </div>

                    <div v-for="n in flex_users_align" class="user-box"></div>

                </div>
                <div class="h30"></div>
            </div>
      
            <div class="h10"></div>
      
          </div>
        </transition>
        <Goback></Goback>
        <div class="h30"></div>
    </div>
</template>
<script>
  import Goback from '@/components/components/goback'
  export default{
    
components:{
            Goback,

        },
    data(){
      return {
        keyword:'',
        users:{},
        users_length:0,

        //users的格式补齐
        flex_users_align:0,
      }
    },
    watch:{
      $route(newVal,oldVal){
        this.users={}
        if(newVal.name == 'searchuser'){
          this.$parent.activeIndex = '0'
        }
        this.keyword = this.$route.params.keyword
      },
      keyword(){
        this.$parent.activeIndex = '0'
        
        this.getUsers();
      }
    },
    methods:{
      //根据关键词获取用户
      getUsers(){
        this.keyword = this.$route.params.keyword
        
        $.ajax({
          url:'//'+ this.$API_URL +'/api/v1/users',
          type:'get',
          data:{keyword:this.keyword},
          success:(ret)=>{
            
            if(ret.data.data.length>0){
              this.users = ret.data.data;
            //   
              
              this.flex_users_align = 6 - (this.users.length % 6)
            }else{
              // this.movies = "暂无数据"
              this.users = []
            }
            this.users_length = this.users.length
            
          }
        })
      },

      //跳转到用户详情页
      goUserinfo(uid){
        this.$router.push('/user/'+uid).catch(err => {err});
      },
    },
    mounted() {
      this.getUsers();
    } 
  }

</script>

<style scoped>
.user-boxes{
    margin:0 20px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    text-align: center;
}
.user-box{
    margin-bottom: 20px;
    width:16%;
    /* height:160px; */
}
.username{
    /* display: block; */
    font-weight: 800;
    font-size:18px;
    color:#3c3c3b;
    text-decoration: none;

    
  }
.ellipsis{

  margin: 5px auto;
    width:160px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.username:hover{
    color:#ff7400;

}
.user-head{
    width:128px;
    height:128px;
    border-radius: 50%;

}

</style>



// WEBPACK FOOTER //
// src/components/index/searchuser.vue